// Flow types automatically removed

import { DesignerDirectoryRenderer } from './DesignerDirectoryRenderer.jsx';
import { QueryParamsProvider } from '../shared/QueryParamsProvider.jsx';
import { QueryParamsConsumer } from '../shared/QueryParamsConsumer.jsx';
import {
    mapQueryParamsToProps,
    mapUpdateToQueryParams,
} from './helpers/designerDirectoryQueryParams.js';
export const DesignerDirectoryContainer = ({ environment, search }) => (
    <QueryParamsProvider search={search}>
        <QueryParamsConsumer
            mapQueryParamsToProps={mapQueryParamsToProps}
            mapUpdateToQueryParams={mapUpdateToQueryParams}
        >
            {(queryParams, onQueryParamsChange) => (
                <DesignerDirectoryRenderer
                    environment={environment}
                    queryParams={queryParams}
                    onQueryParamsChange={onQueryParamsChange}
                />
            )}
        </QueryParamsConsumer>
    </QueryParamsProvider>
);
